import { CvcBox } from '@apply/components';
import { CardFocusType } from '../../../../../constants/CardFocusType';
import { useCustomPaymentCardFocus, useCustomPaymentCVC } from '../../../../../fields/CustomPaymentFields';
interface CardCvcParameters {
    customPaymentId: string;
    disabled: boolean;
}
export const CardCvc: React.FC<CardCvcParameters> = ({ customPaymentId, disabled }) => {
    const [cvc, set_cvc] = useCustomPaymentCVC(customPaymentId);
    const [, set_cardFocus] = useCustomPaymentCardFocus(customPaymentId);

    return (
        <CvcBox
            name='cvc'
            label='CVC'
            value={cvc}
            onChange={(value) => set_cvc(value)}
            onFocusIn={() => set_cardFocus(CardFocusType.CVC)}
            disabled={disabled}
        />
    );
};
